import Vue from 'vue';
const EventBus = new Vue();
export default EventBus;

export const OPEN_ACCESS_LAYER = "openAccessLayer"
